import request from '@/utils/request'

export function getAction(url,parameter) {
  if(!parameter) {
	  parameter = {isCache: true}
  }
  return request({
    url: url,
    method: 'get',
    params: parameter
  })
}

export function postAction(url,parameter) {
  return request({
    url: url,
    method:'post' ,
    data: parameter
  })
}